import { useDemand2Scope } from "~/components/demand-2/useDemand2Scope"
import { api } from "~/utils/api"
import { hasAnyPlannedMarkdown } from "~/utils/budgetMarkdown"
import { useFlags } from "~/features/feature-flags"

/**
 * Whether the budget this route reconciles against plans any markdown, and its name. Reads only the
 * saved distribution, so it is cheap enough for the Demand configuration dialog. Always false with
 * the `budget` flag off.
 */
export const useBudgetMarkdowns = () => {
  const { budget: budgetFlag } = useFlags()
  const { scopeId, isGroup, isPortfolio } = useDemand2Scope()
  const budgetQ = api.budgets.getReconciliationBudget.useQuery(
    { collectionId: scopeId, isGroup },
    { enabled: !!budgetFlag && !isPortfolio && Number.isFinite(scopeId) },
  )
  const budget = budgetQ.data?.budget ?? null
  const distributionQ = api.budgets.getBudgetDistribution.useQuery(
    { budgetId: budget?.id ?? 0 },
    { enabled: !!budgetFlag && budget != null, select: hasAnyPlannedMarkdown },
  )
  return {
    budgetName: budget?.name ?? null,
    hasMarkdowns: !!budgetFlag && budget != null && distributionQ.data === true,
  }
}
